import 'Navigation/angularModule';

export default angular.module('FrontRoyal.AddToCalendarWidget', ['FrontRoyal.Navigation']);
